<div class="mms-worksheet p-20 m-0-auto">

    <div class="text-a-right" *ngIf="enableDownload">
        <button nz-button class="m-r-20" [nzType]="'primary'" translate (click)="downloadPDF()">Download</button>
    </div>
    <div id="uwWorksheetSection">
    <!-- Header -->
    <div class="mms-ws-header">
        <div class="flex flex-horiz-space-bw">
            <div *ngIf="enableLogo">
                <img src="/assets/images/{{organizationMetaData.logoname}}" alt="LOGO" class="mms-ws-header-logo"
                    style="height: 50px;margin-bottom: 15px" />
            </div>
            <div class="mms-ws-header-addr">
                <!-- Ninad's Review: This has to be changed, please understand which address is to be populated below.  -->
                <!-- <h5>MetaMorphoSys Insurance Corp.</h5>
        <p>Himgiri Bungalow, LA-Ratan Lane</p>
        <p>Baner, MH 411045</p> -->
            </div>
        </div>
    </div>

    <!-- Claim Details -->
    <div>
        <div class="title-emphasis">
            <!-- <i class="title-ico anticon anticon-audit"></i> -->
            <span nz-icon nzType="audit" nzTheme="outline" class="title-ico"></span>
            <div>
                <h4 class="p-0 m-0">Underwriting Worksheet</h4>
                <span class="col-grey-dark"> {{proposalIO?.proposalNum}}</span>
            </div>
        </div>

        <!-- Summary -->

        <div class="underwriting-container summary-container-wide">
            <div>

                <span class="s-c-head">Proposal No</span>
                <span
                    *ngIf="selectedPolicyDO?.proposalNum">{{selectedPolicyDO?.proposalNum || '' | translate}}</span>
                <span
                    *ngIf="selectedPolicyDO?.proposalNum ==null">{{selectedPolicyDO?.proposalNum || '' | translate}}</span>
                    <span
                    *ngIf="selectedpolicy?.proposalNum">{{selectedPolicyDO?.proposalNum || '' | translate}}</span>
            </div>
            <div>
                <span
                    class="s-c-head">Product</span>{{selectedPolicyDO?.baseProductCd || '' | technicalTranslate}}
                <span *ngIf="selectedPolicyDO?.baseProductCd ==null">-</span>
            </div>
            <!-- <div>
        <span class="s-c-head">Plan</span> {{selectedPolicyDO?.baseProductTypeCd || '' | translate}}
        <span *ngIf="selectedPolicyDO?.baseProductTypeCd ==null">-</span>
      </div> -->
            <!-- <div>
        <span
          class="s-c-head">Package</span>{{(selectedPolicyDO?.productPlanOptionCd | technicalTranslate) || ''}}
        <span *ngIf="selectedPolicyDO?.productPlanOptionCd ==null">-</span>
      </div> -->
            <div>
                <span class="s-c-head">Proposal Signed Date</span>
                <nz-badge nzStatus="success">{{getDateString(selectedPolicyDO?.policyExpiryDt)}} </nz-badge>
            </div>
            <div>
                <span class="s-c-head">Proposal Received Date</span>
                <nz-badge class="d-b">{{getDateString(selectedPolicyDO?.policyCommencementDt)}}</nz-badge>
            </div>
            <div>
                <span class="s-c-head">Policy Issuance Date</span>
                <nz-badge nzStatus="success">{{getDateString(selectedPolicyDO?.policyExpiryDt)}} </nz-badge>
            </div>
            <div>
                <span class="s-c-head">Risk Commencement Date</span>
                <nz-badge class="d-b">{{getDateString(selectedPolicyDO?.policyCommencementDt)}}</nz-badge>
            </div>
            <div>
                <span class="s-c-head">Channel</span>
                <span>-</span>

            </div>

            <div>
                <span class="s-c-head">Total {{appMetadataHandler.SI_LABEL}}</span>
                {{selectedPolicyDO?.sumInsured | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}
                <!-- <span *ngIf="item?.caseDO?.sumInsured ==null">-</span> -->
            </div>
            <div>
                <span class="s-c-head">Premium</span> {{selectedPolicyDO?.finalPremiumAmt | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}
                <!-- <span *ngIf="item?.caseDO?.finalPremiumAmt ==null">-</span> -->
            </div>
            <div>
                <span class="s-c-head">Premium Status</span>
                <nz-tag *ngIf="selectedPolicyDO?.premiumStatusCd" [nzColor]="selectedPolicyDO?.premiumStatusCd=='OUTSTANDING' ? 'brown' : 'green'">
                    {{(selectedPolicyDO?.premiumStatusCd | technicalTranslate ) || ''}}</nz-tag>
                <span *ngIf="selectedPolicyDO?.premiumStatusCd ==null">-</span>
            </div>
            <div>
                <span class="s-c-head">Policy Holder</span>
                <span>{{ownerClientDO | MMSClientData: 'firstName'}}
                    {{ownerClientDO | MMSClientData: 'lastName'}}</span>

            </div>
            <div *ngIf="listOfinsured && listOfinsured.length > 0 && listOfinsured[0].personDO">

                <span class="s-c-head">Primary Insured</span>
                {{listOfinsured[0]?.personDO?.firstName || '' | translate}}
                {{listOfinsured[0]?.personDO?.lastName || '' | translate}}
                <span *ngIf="listOfinsured[0]?.personDO?.firstName == null">-</span>
            </div>

        </div>
        <!--Benefit start  -->
        <!-- <div>
            <h4 class="p-t-b-10">Policy Benefit</h4>
            <div>
                <div class="list-benefits">

                    <nz-table #benefitTable [nzData]="benefitList" [nzShowPagination]="false" class="valign-top">
                        <thead>
                            <tr>
                                <th>Cover Name</th>
                                <th>Benefit</th>
                                <th>Benefit Amount</th>
                                <th>Approved Amount</th>
                                <th>Decision</th>

                            </tr>
                        </thead>
                        <tbody class="valign-top">
                            <tr class="v-a-top" *ngFor="let item of benefitList">
                                <td>{{item.productCd}}</td>
                                <td>{{item.benefitCd}}</td>
                                <td>{{item.benefitAmt}}</td>
                                <td>
                                    {{item.benefitAmt}}
                                </td>
                                <td>
                                    {{item.decisionCd}}
                                </td>
                            </tr>
                        </tbody>
                    </nz-table>
                </div>
            </div>
        </div> -->
        <!--End Benefit  -->

        <!-- <div class="title-emphasis m-t-30" *ngIf="underwritingSummary"> -->
            <!-- <i class="title-ico anticon anticon-audit"></i> -->
            <!-- <span nz-icon nzType="file-text" nzTheme="outline" class="title-ico"></span> -->
            <!-- <div> -->
                <!-- <h4 class="p-0 m-0">Underwriting Summary</h4> -->
                <!-- <span class="col-grey-dark"> {{proposalIO?.proposalNum}}</span> -->
            <!-- </div> -->
        <!-- </div> -->

        <!-- <div class="underwritingSummarySec" *ngIf="underwritingSummary">
            {{underwritingSummary}}
        </div> -->

        <div *ngIf="otherPolicyList && otherPolicyList.length > 0">
            <h4 class="p-t-b-10">Other Policy Details</h4>
            <div>
                <div class="list-benefits">

                    <nz-table #otherPolicyListTable [nzData]="otherPolicyList" [nzShowPagination]="false"
                        class="valign-top">
                        <thead>
                            <tr>
                                <th>Insurance Provider</th>
                                <th>Proposal Number</th>
                                <th>{{appMetadataHandler.SI_LABEL}}</th>
                                <th>Premium</th>
                                <th>Policy Status</th>

                            </tr>
                        </thead>
                        <tbody class="valign-top">
                            <tr class="v-a-top" *ngFor="let item of otherPolicyListTable.data">
                                <td>{{item.provider}}</td>
                                <td>{{item.proposalNum}}</td>
                                <td>{{item.sumInsured | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                                <td>
                                    {{item.premium | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}
                                </td>
                                <td>
                                    {{item.statusCd}}
                                </td>
                            </tr>
                        </tbody>
                    </nz-table>
                </div>
            </div>

        </div>


        <div class="title-emphasis m-t-40">
            <!-- <i class="title-ico anticon anticon-usergroup-add"></i> -->
            <span nz-icon nzType="usergroup-add" nzTheme="outline" class="title-ico"></span>
            <div>
                <h4 class="p-0 m-0">Primary Insured, Payer & Nominees</h4>
                <!-- <span class="col-grey-dark">{{proposalIO?.claimNum}}</span> -->
            </div>
        </div>


        <h3 *ngIf="listOfPrimaryInsured && listOfPrimaryInsured.length" class="d-b m-t-20 heading">Primary Insured</h3>
        <nz-table *ngIf="listOfPrimaryInsured && listOfPrimaryInsured.length" #claimTable [nzData]="listOfPrimaryInsured" [nzShowPagination]="false"
            nzSize="small">
            <thead class="table-header">
                <tr>
                    <th>Name</th>
                    <th>Date Of Birth</th>
                    <th>Contact</th>
                    <th>Address</th>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row" *ngFor="let data of listOfPrimaryInsured">
                    <td>{{data?.personDO?.firstName}} {{data?.personDO?.lastName}}</td>
                    <td *ngIf="data && data.personDO">{{getDateString(data.personDO.dateOfBirth)}}</td>
                    <td *ngIf="data && data.clientContactDetailsList && data.clientContactDetailsList.length > 0">
                        {{data.clientContactDetailsList[0]?.contactNum}}

                    </td>
                    <!-- <td>{{ getAddress(data) }}{{data.clientAddressList[0].addressLine1}} {{data.clientAddressList[0].addressLine2}} {{data.clientAddressList[0].typeCd}}</td> -->
                    <td>
                        <span *ngFor="let address of data.clientAddressList; let i = index;">
                            <!-- <b>Address {{i+1}}:</b> -->
                            {{address?.addressLine1}} {{address?.addressLine2}} {{address?.addressLine3}},
                            {{address?.cityCd | technicalTranslate}}, {{address?.countryCd | technicalTranslate}},{{address?.postCode}}
                            ({{address?.typeCd}})
                        </span>
                    </td>
                </tr>
            </tbody>
        </nz-table>

        <h3 *ngIf="listOfinsured && listOfinsured.length" class="d-b m-t-20 heading">Insured</h3>
        <nz-table *ngIf="listOfinsured && listOfinsured.length" #claimTable [nzData]="listOfinsured" [nzShowPagination]="false" nzSize="small">
            <thead class="table-header">
                <tr>
                    <th>Name</th>
                    <th>Date Of Birth</th>
                    <th>Contact</th>
                    <th>Address</th>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row" *ngFor="let data of listOfinsured">
                    <td>{{data?.personDO?.firstName}} {{data?.personDO?.lastName}}</td>
                    <td *ngIf="data && data.personDO">{{getDateString(data.personDO.dateOfBirth)}}</td>
                    <td *ngIf="data && data.clientContactDetailsList && data.clientContactDetailsList.length > 0">
                        {{data.clientContactDetailsList[0]?.contactNum}}

                    </td>
                    <!-- <td>{{ getAddress(data) }}{{data.clientAddressList[0].addressLine1}} {{data.clientAddressList[0].addressLine2}} {{data.clientAddressList[0].typeCd}}</td> -->
                    <td>
                        <span *ngFor="let address of data.clientAddressList; let i = index;">
                            <!-- <b>Address {{i+1}}:</b> -->
                            {{address?.addressLine1}} {{address?.addressLine2}} {{address?.addressLine3}},
                            {{address?.cityCd | technicalTranslate}}, {{address?.countryCd | technicalTranslate}},{{address?.postCode}}
                            ({{address?.typeCd}})
                        </span>
                    </td>
                </tr>
            </tbody>
        </nz-table>

        <h3 *ngIf="nomineelist && nomineelist.length" class="d-b m-t-20 heading">Nominees</h3>
        <nz-table *ngIf="nomineelist && nomineelist.length" #claimTable [nzData]="nomineelist" [nzShowPagination]="false" nzSize="small">
            <thead class="table-header">
                <tr>
                    <th>Name</th>
                    <th>Date Of Birth</th>
                    <th>Contact</th>
                    <th>Address</th>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row" *ngFor="let data of nomineelist">
                    <td>{{data?.personDO?.firstName}} {{data?.personDO?.lastName}}</td>
                    <td> <span *ngIf="data && data.personDO">{{getDateString(data.personDO.dateOfBirth)}}</span></td>
                    <td>
                        <span
                            *ngIf="data.clientContactDetailsList && data.clientContactDetailsList.length > 0">{{data.clientContactDetailsList[0].contactNum}}</span>
                    </td>
                    <!-- <td>
            {{ getAddress(data) }} {{data.clientAddressList[0].addressLine1}} {{data.clientAddressList[0].addressLine2}} {{data.clientAddressList[0].typeCd}} -->
                    <!-- </td>   -->
                    <td>
                        <span *ngFor="let address of data.clientAddressList; let i = index;">
                            <!-- <b>Address {{i+1}}:</b> -->
                            {{address?.addressLine1}} {{address?.addressLine2}} {{address?.addressLine3}},
                            {{address?.cityCd | technicalTranslate}}, {{address?.countryCd | technicalTranslate}},{{address?.postCode}}
                            ({{address?.typeCd}})
                        </span>
                    </td>
                </tr>

            </tbody>
        </nz-table>

        <h3 *ngIf="payerList && payerList.length" class="d-b m-t-20 heading">Payer</h3>
        <nz-table *ngIf="payerList && payerList.length" #payerTable [nzData]="payerList" [nzShowPagination]="false" nzSize="small">
            <thead class="table-header">
                <tr>
                    <th>Name</th>
                    <th>Date Of Birth</th>
                    <th>Contact</th>
                    <th>Address</th>
                </tr>
            </thead>
            <tbody>
                <!-- test  {{clamantlist | json}} -->
                <tr class="table-row" *ngFor="let data of payerTable.data">
                    <td> {{data?.personDO?.firstName}} {{data?.personDO?.lastName}}</td>
                    <td> <span *ngIf="data && data.personDO">{{getDateString(data.personDO.dateOfBirth)}}</span></td>
                    <td>
                        <span
                            *ngIf="data.clientContactDetailsList && data.clientContactDetailsList.length > 0">{{data.clientContactDetailsList[0].contactNum}}</span>
                    </td>
                    <td>
                        <span *ngFor="let address of data.clientAddressList; let i = index;">
                            <!-- <b>Address {{i+1}}:</b> -->
                            {{address?.addressLine1}} {{address?.addressLine2}} {{address?.addressLine3}},
                            {{address?.cityCd | technicalTranslate}}, {{address?.countryCd | technicalTranslate}},{{address?.postCode}}
                            ({{address?.typeCd}})
                        </span>
                        <!-- <span>  {{data.clientAddressList|json}}</span>  -->
                        <!-- {{ getAddress(data) }}     -->
                    </td>
                </tr>
            </tbody>
        </nz-table>

        <h3 *ngIf="finalDecisionList && finalDecisionList.length>0" class="d-b m-t-20 heading">Final decision</h3>
        <nz-table *ngIf="finalDecisionList  && finalDecisionList.length>0" #claimTable [nzData]="finalDecisionList" [nzShowPagination]="false"
            nzSize="small">
            <thead class="table-header">
                <tr>
                    <th>Insured Name</th>
                    <th>Rule</th>
                    <th>Financial/Medical UW Decision</th>
                    <th>Remarks ( if it is reffered to uw, then need to mention why is it reffered)</th>
                </tr>
            </thead>
            <tbody>
                <tr class="table-row" *ngFor="let data of finalDecisionList">
                    <td>-</td>
                    <td> {{data?.productCd | technicalTranslate: 'productId'}}</td>
                    <td> {{data?.sumInsured | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                    <td> {{data?.totalPremiumAmt | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                </tr>
            </tbody>
        </nz-table>

        <h3 *ngIf="coveragesDecisionList && coveragesDecisionList.length" class="d-b m-t-20 heading">Coverage wise decision</h3>
        <nz-table *ngIf="coveragesDecisionList && coveragesDecisionList.length" #coverageTable [nzData]="coveragesDecisionList"
            [nzShowPagination]="false" nzSize="small">
            <thead class="table-header">
                <tr>
                    <!-- <th>Insured Name</th> -->
                    <th>Cover Name</th>
                    <th>{{appMetadataHandler.SI_LABEL}}</th>
                    <th>Premium</th>
                    <th>Decision</th>
                    <!-- <th>Suggested Actions</th> -->
                </tr>
            </thead>
            <tbody>
                <tr class="table-row" *ngFor="let data of coverageTable.data">
                    <!-- <td>-</td> -->
                    <td> {{(data?.productCd | technicalTranslate: 'productId') || (data.planTypeCd | technicalTranslate)}}</td>
                    <td> {{data?.sumInsured | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                    <td> {{data?.totalPremiumAmt | CurrencyFormatter: (selectedPolicyDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
                    <td>{{(data?.uwDecisionCd | technicalTranslate) || '-' }}</td>
                    <!-- <td>-</td> -->
                </tr>
            </tbody>
        </nz-table>

    </div>
    </div>
</div>